module.exports = __webpack_public_path__ + "img/illustration_korean_bbq.59980e5c.png";